module.exports = __webpack_public_path__ + "img/asset_fault.c6a096f0.svg";